import { Vector } from "@/components/ui/vector";
import { useFooter } from "./use-footer";
import { Social } from "../social";

export const Footer = () => {
  const { styles } = useFooter();

  return (
    <footer className={styles.base()}>
      <div className={styles.container()}>
        <div className={styles.content()}>
          <a
            href="https://moreiraeruffos.com.br/"
            title="Moreira & Ruffos Construtora"
            target="_blank"
          >
            <Vector name="company" className={styles.brand()} />
          </a>
          <Social title="Siga nas redes sociais" />
        </div>
      </div>
    </footer>
  );
};
